import positionBg from "./positionbg.png"
export const Position = () => {
 return (
  <div className="w-[96%] mx-auto relative h-screen md:h-screen lg:h-full pt-6">
   <h1 className="Jakarta-font font-semibold mx-6 py-1">Position</h1>

   <div
    style={{
     backgroundImage: `url(${positionBg})`,
     backgroundPosition: "left",
     backgroundSize: "contain",
     width: "100%",
     minHeight: "560px",
     backgroundRepeat: "no-repeat",
    }}
   ></div>
  </div>
 )
}
